import AllBillingLogsPage from "./AllBillingLogsPage";

export default AllBillingLogsPage;
